import { CLASS_ACTIVITY_ITEM } from '../../../../../boardDetails/activity/TabActivity/components/constants';
import * as React from 'react';
import { IAssigneesContent } from './types';
import { blockMarkdown } from '../../../../../../../../helper/markdownHelper';
import {
    CLASS_CARD_ACTIVITY_ITEM_ADD_VALUE
} from '../../../../../boardDetails/activity/TabActivity/components/ActivityItemBody/constants';
import ReactHtmlParser from 'react-html-parser';

export function AssigneesContent({
    value,
}: IAssigneesContent) {
    return <div className={CLASS_CARD_ACTIVITY_ITEM_ADD_VALUE + ' ' + CLASS_ACTIVITY_ITEM + '__checklist-name'}>
        {ReactHtmlParser(blockMarkdown(value))}
    </div>;
}
